<script>
    import * as Sentry from '@sentry/sveltekit';
    import { activeUserData, get_osm_uid_state } from './activeUserData.svelte.js';
    import { tick } from 'svelte';
    import { mapDisplayMessage, toggle_visit, keydownWrapper } from './lib.js';
    import { showContextMenu  } from './Map.svelte';

    let {
        osm_uid = null,
        label,
        token,
        map = null,
        autofocus = false,
        flyToOnBeen = false,
        capacitor,
    } = $props();

    let error = $state(null);
    let disabled = $state(false);
    let wait = $state(false);
    let the_button;
    let osm_uid_state = $derived.by(() => { return get_osm_uid_state (activeUserData.data, osm_uid); });

    $effect(() => {
        if(autofocus && the_button) {
            the_button.focus();
        }
    });

    if(!osm_uid) {
        Sentry.captureMessage("BeenButton created with an falsy osm_uid", { extra: { osm_uid } });
    }

    function onContextMenu(event) {
        event.preventDefault(); // Prevent browser context menu
        event.stopPropagation();
        showContextMenu({el: event.currentTarget, osm_uid, label, flyToOnBeen });
    }

    async function toggleBeenTo(e) {
        e.preventDefault();
        if(capacitor) {
            await capacitor.hapticsImpactLight();
        }
        disabled = true;
        wait = true;

        if(!osm_uid) {
            Sentry.captureMessage('BeenButton/toggleBeenTo: empty osm_uid', { extra: { osm_uid_state, osm_uid } });
            return;
            // Note, the button will stay disabled
        }

        error = await toggle_visit (map, osm_uid_state.visited ? 'remove' : 'add', { osm_uid, flyToOnBeen, token });
        wait = false;
        if(!error) {
            disabled = false;
        } else {
            if(capacitor) {
                await capacitor.hapticsImpactMedium();
            }
        }
        await tick();
        the_button.focus();
    }

    $effect(() => {
        if(error) {
            mapDisplayMessage({map, msg: error, type: 'danger'});
            const mymap_add_error = document.getElementById("mymap_add_error");
            if(mymap_add_error) {
                mymap_add_error.innerHTML = error;
            }
        }
    });

    let touchTimer;
</script>
<!-- svelte-ignore a11y_autofocus -->
<button class="m-1 button is-small cursor-pointer"
    bind:this={the_button}
    id={osm_uid}
    {disabled}
    class:is-loading={disabled}
    class:wait={wait}
    class:is-danger={!!error} 
    class:is-success={osm_uid_state.visited && !osm_uid_state.transit}
    class:is-link={osm_uid_state.visited && osm_uid_state.transit}
    class:is-outlined={osm_uid_state.hidden}
    onclick={toggleBeenTo}
    onkeydown={keydownWrapper(toggleBeenTo)}
    oncontextmenu={onContextMenu}
    ontouchstart={(event) => { touchTimer = setTimeout(() => onContextMenu(event), 500 /* 500ms long press threshold */)}}
    ontouchend={() => clearTimeout(touchTimer)}
>
    {#if capacitor}
        <svg class=svg-icon>
            <use xlink:href={osm_uid_state.visited ? "/i/fa.svg#circle-check" : "/i/fa.svg#circle"}/>
        </svg>
    {:else}
        <svg class=svg-icon>
            <use xlink:href={osm_uid_state.visited ? "/i/fa.svg#circle-check" : "/i/fa.svg#circle"}/>
        </svg>&nbsp;Been
    {/if}
</button>

<style>
    button.wait {
        cursor: wait !important;
    }
</style>
